import * as React from 'react'
import './Footer.sass'
import logoFacebook from '../../images/logo-facebook.svg'
import logoLinkedin from '../../images/logo-linkedin.svg'
import logoTwitter from '../../images/logo-twitter.svg'

export const Footer: React.SFC<{}> = (props) => {
  return (
    <footer>
      <div className="content">
        <nav className="links">
          <a href="https://letsenhance.io/privacy" target="_blank" rel="noreferrer">Privacy Policy</a>
          <a href="https://letsenhance.io/terms" target="_blank" rel="noreferrer">Terms & Conditions</a>
          <a href="https://medium.com/@letsenhance_io" target="_blank" rel="noreferrer">Blog</a>
          <a href="https://angel.co/let-s-enhance-1" target="_blank" rel="noreferrer">Jobs</a>
        </nav>
        <nav className="social">
          <a href="mailto:hello@letsenhance.io" className="text-with-gradient email">hello@letsenhance.io</a>
          <div className="social-links">
            <a href="https://www.linkedin.com/company/letsenhance/" target="_blank" rel="noreferrer">
              <img src={logoLinkedin} alt="Linkedin" />
            </a>
            <a href="https://www.facebook.com/letsenhance/" target="_blank" rel="noreferrer">
              <img src={logoFacebook} alt="Facebook" />
            </a>
            <a href="https://twitter.com/letsenhance_io" target="_blank" rel="noreferrer">
              <img src={logoTwitter} alt="Twitter" />
            </a>
          </div>
        </nav>
      </div>
    </footer>
  )
}